// src/components/UserManagement/UserFilterModal.jsx
import React from "react";
import { Modal, Form, Select, DatePicker, Button, Space } from "antd";

export default function UserFilterModal({ open, onCancel, onApply }) {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    const payload = {
      ...values,
      dob: values.dob ? values.dob.format("YYYY-MM-DD") : null,
    };
    onApply(payload);
  };

  return (
    <Modal
      title="Filter Users"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        {/* User Type */}
        <Form.Item name="userType" label="User Type">
          <Select placeholder="Select type">
            <Select.Option value="">All</Select.Option>
            <Select.Option value={2}>Agent</Select.Option>
            <Select.Option value={3}>Customer</Select.Option>
          </Select>
        </Form.Item>

        {/* User Status */}
        <Form.Item name="userStatus" label="User Status">
          <Select placeholder="Select status">
            <Select.Option value="">All</Select.Option>
            <Select.Option value={1}>Active</Select.Option>
            <Select.Option value={0}>Suspended</Select.Option>
          </Select>
        </Form.Item>

        {/* Date of Birth */}
        <Form.Item name="dob" label="Date of Birth">
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Apply Filters
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}
